import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './ExtraMileHeader.css';

const FROM_MOBILE_APP_STORAGE_KEY = 'hf_fromMobileApp';

/** PHP actions-default back() targets for Brain Teasers. */
function inAppBackTarget(pathname) {
  const p = pathname.replace(/\/+$/, '') || '/';
  if (p === '/rules') return '/';
  if (p === '/rounds/1') return '/rules';
  if (p === '/rounds/2') return '/rounds/1';
  if (p === '/rounds/3') return '/rounds/2';
  if (p === '/rounds/4') return '/rounds/3';
  if (p === '/thank-you') return null;
  return null;
}

export default function ExtraMileHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { companyLogoUrl, backButtonUrl } = useSelector((s) => s.ui);
  const user = useSelector((s) => s.auth.user);
  const [logoUrl, setLogoUrl] = useState('');
  const [backUrl, setBackUrl] = useState('');

  useEffect(() => {
    setBackUrl(backButtonUrl || user?.backButtonRedirect || '');
    setLogoUrl(companyLogoUrl || process.env.REACT_APP_EM_LOGO || '');
  }, [backButtonUrl, companyLogoUrl, user]);

  const fromMobileAppInUrl = searchParams.get('fromMobileApp') === 'true';
  useEffect(() => {
    if (!fromMobileAppInUrl) return;
    try {
      sessionStorage.setItem(FROM_MOBILE_APP_STORAGE_KEY, 'true');
    } catch {
      /* ignore */
    }
  }, [fromMobileAppInUrl]);

  const isFromMobileApp = useMemo(() => {
    let fromSession = false;
    try {
      fromSession = sessionStorage.getItem(FROM_MOBILE_APP_STORAGE_KEY) === 'true';
    } catch {
      fromSession = false;
    }
    return fromMobileAppInUrl || fromSession;
  }, [fromMobileAppInUrl]);

  /* Native app has its own back; hide in-game Back when opened via fromMobileApp */
  const hideBackButton = isFromMobileApp;

  useEffect(() => {
    if (!backUrl) return;

    const handleBrowserBack = () => {
      window.location.href = backUrl;
    };

    window.history.pushState({ hfBackHandled: true }, '', window.location.href);
    window.addEventListener('popstate', handleBrowserBack);
    return () => window.removeEventListener('popstate', handleBrowserBack);
  }, [backUrl, location.pathname]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.('navigate_back');
  };

  const onBackClick = (e) => {
    e.preventDefault();
    const inApp = inAppBackTarget(location.pathname);
    if (inApp) {
      navigate(inApp);
      return;
    }
    if (location.pathname === '/thank-you') {
      window.location.href =
        backUrl ||
        user?.backButtonRedirect ||
        process.env.REACT_APP_BASE_URL ||
        '/';
      return;
    }
    if (backUrl) {
      window.location.href = backUrl;
      return;
    }
    if (window.history.length > 1) navigate(-1);
    else window.location.href = process.env.REACT_APP_BASE_URL || '/';
  };

  return (
    <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL || '/'} onClick={handleLogoClick}>
        {logoUrl ? <img src={logoUrl} className="logo-holder" alt="ExtraMile Play" /> : null}
      </a>
      {!hideBackButton ? (
        <div className="back-holder">
          <button type="button" className="back-default" onClick={onBackClick}>
            Back
          </button>
        </div>
      ) : null}
    </header>
  );
}
